var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0004 7.95069C10.2493 7.69752 10.2458 7.2905 9.99265 7.04159C9.73948 6.79268 9.33246 6.79613 9.08355 7.04931L7.04159 9.12623C6.79566 9.37637 6.79566 9.77748 7.04159 10.0276L9.08355 12.1045C9.33246 12.3577 9.73948 12.3612 9.99265 12.1123C10.2458 11.8633 10.2493 11.4563 10.0004 11.2032L9.03355 10.2198L13.2857 10.2198C13.6408 10.2198 13.9286 9.93196 13.9286 9.57692C13.9286 9.22188 13.6408 8.93407 13.2857 8.93407L9.03355 8.93407L10.0004 7.95069ZM14.9165 11.8955C14.6675 11.6423 14.2605 11.6388 14.0073 11.8877C13.7542 12.1367 13.7507 12.5437 13.9996 12.7968L14.9664 13.7802L10.7143 13.7802C10.3592 13.7802 10.0714 14.068 10.0714 14.4231C10.0714 14.7781 10.3592 15.0659 10.7143 15.0659L14.9664 15.0659L13.9996 16.0493C13.7507 16.3025 13.7542 16.7095 14.0073 16.9584C14.2605 17.2073 14.6675 17.2039 14.9165 16.9507L16.9584 14.8738C17.2043 14.6236 17.2043 14.2225 16.9584 13.9724L14.9165 11.8955Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfer);
export default __webpack_public_path__ + "static/media/icon_transfer.559afc4f00eb0fbd0fd6b795a04c9c40.svg";
export { ForwardRef as ReactComponent };